module.exports = __webpack_public_path__ + "media/images/arrows/twisted/orange-3-377094950d5f2cb3c66ea870d3c0eed8.svg";